import { render, staticRenderFns } from "./OffersPreview.vue?vue&type=template&id=8c28db6a&scoped=true&"
import script from "./OffersPreview.vue?vue&type=script&lang=js&"
export * from "./OffersPreview.vue?vue&type=script&lang=js&"
import style0 from "./OffersPreview.vue?vue&type=style&index=0&id=8c28db6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c28db6a",
  null
  
)

export default component.exports